<nz-tree-view
  [nzDataSource]="dataSource"
  [nzTreeControl]="treeControl"
  [trackBy]="trackBy">
  <nz-tree-node
    class="node"
    nzTreeNodeIndentLine
    *nzTreeNodeDef="let node">
    <!-- TODO: Waiting for Ado's decision, how will it look and where it will be -->
    <!-- <div class="button-absolute-anchor">
      <ui-platform-button
        type="text"
        label="D"
        nz-tooltip
        nzTooltipTitle="Duplicate this IRO"
        class="duplicate-button"
        [classes]="['ant-btn-add']"
        (click)="onAddButtonClick(node, true)"></ui-platform-button>
    </div> -->

    <nz-tree-node-checkbox
      [nzChecked]="checklistSelection.isSelected(node)"
      [nzDisabled]="node.disabled"
      (nzClick)="itemSelectionToggle(node)"></nz-tree-node-checkbox>
    <span>{{ node.label | transloco }}</span>
  </nz-tree-node>

  <nz-tree-node
    class="node with-form"
    nzTreeNodeIndentLine
    *nzTreeNodeDef="let node; when: hasNoContent">
    <div class="input-wrapper">
      <input
        nz-input
        #inputElement
        [placeholder]="'general.input-iro-name.title' | transloco"
        [value]="node.label | transloco" />
      @if (node.label && node.label === inputElement.value) {
        <p>Please change name</p>
      }
    </div>
    <ui-platform-button
      type="primary"
      [label]="'profile.admin.drawer.add' | transloco"
      (click)="onSaveNodeClick(node, inputElement.value)"></ui-platform-button>
    <ui-platform-button
      type="text"
      [label]="'general.cancel' | transloco"
      (click)="onCancelNodeClick(node)"></ui-platform-button>
  </nz-tree-node>

  <nz-tree-node
    class="node parent"
    nzTreeNodeIndentLine
    *nzTreeNodeDef="let node; when: hasChild">
    <nz-tree-node-toggle>
      <ui-icon key="chevron-right"></ui-icon>
    </nz-tree-node-toggle>
    <span> {{ node.label | transloco }}</span>
  </nz-tree-node>

  <nz-tree-node
    class="node parent with-add-button"
    nzTreeNodeIndentLine
    *nzTreeNodeDef="let node; when: hasAddButton">
    <nz-tree-node-toggle>
      <ui-icon key="chevron-right"></ui-icon>
    </nz-tree-node-toggle>
    <span> {{ node.label | transloco }}</span>
    @if (treeControl.isExpanded(node)) {
      <ui-platform-button
        type="text-primary"
        [label]="addButtonLabel | transloco"
        (click)="onAddButtonClick(node)"></ui-platform-button>
    }
  </nz-tree-node>
</nz-tree-view>
